// extracted by mini-css-extract-plugin
export default {"tableBase":"style_tableBase__2NeaF","tableAllowed":"style_tableAllowed__FyY23","tableApplied":"style_tableApplied__qSBd7","tableActions":"style_tableActions__m0j+V"};